"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledBlockListItem = exports.StyledItemLink = exports.StyledItemButton = exports.StyledItem = exports.StyledUl = exports.StyledContent = exports.StyledTrigger = void 0;
const react_popover_1 = require("@radix-ui/react-popover");
const styled_components_1 = __importStar(require("styled-components"));
const tokens_1 = require("../../styles/tokens");
const Popover_constants_1 = require("./Popover.constants");
const { silver, white } = tokens_1.COLOURS.greyscale;
const { blue } = tokens_1.COLOURS.primary;
const StyledTrigger = (0, styled_components_1.default)(react_popover_1.Trigger) `
    border: none;
    background: transparent;
    padding: 0;
    border-radius: ${({ radius }) => radius};
`;
exports.StyledTrigger = StyledTrigger;
const StyledContent = (0, styled_components_1.default)(react_popover_1.Content) `
    border-radius: ${tokens_1.BORDERS.radius};
    padding: ${tokens_1.SIZES[1]};
    box-shadow: 0 ${tokens_1.SIZES[0.5]} ${tokens_1.SIZES[2]} rgb(68 72 126 / 32%);
    width: ${({ width }) => (width ? width : Popover_constants_1.DEFAULT_POPOVER_CONTENT_WITDH)};
    max-height: 400px;
    overflow-y: auto;
    background-color: ${white};

    /*
    One of the changes introduced in @radix-ui/popover version 1.0.0 was the z-index of the Content was set to auto.
    Setting this here to the value it was by default in earlier versions, since our clients rely on it being set.
     */
    z-index: 2147483001;

    hr {
        border-left: 0;
        border-right: 0;
        border-top: 1px solid ${silver};
    }
`;
exports.StyledContent = StyledContent;
const StyledUl = styled_components_1.default.ul `
    margin: 0;
    padding: 0;
`;
exports.StyledUl = StyledUl;
const popoverItemStyles = (0, styled_components_1.css) `
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    padding: ${tokens_1.SIZES[1.5]};
    margin: ${tokens_1.SIZES[0.5]} 0;
    border-radius: ${tokens_1.BORDERS.radius};

    &:focus {
        /* !important to overwrite globalstyle specificity */
        box-shadow: none !important;
    }

    /* Clickable state */
    ${({ onClick, href }) => (onClick || href) &&
    (0, styled_components_1.css) `
            cursor: pointer;
            &:hover,
            &:focus-visible {
                background-color: ${blue[10]};
                transition: background-color 0.2 ease-in;
            }
        `}

    /* Active state */
    ${({ active }) => active &&
    (0, styled_components_1.css) `
            cursor: default;
            background-color: ${blue[10]};
            border-left: ${blue[100]} solid ${tokens_1.SIZES[0.5]};
            path {
                fill: ${blue[100]};
            }
        `}

    /* Two items next together (ie: icon + text) */
    * + * {
        margin-left: ${tokens_1.SIZES[1]};
    }
`;
const StyledItem = styled_components_1.default.li `
    ${popoverItemStyles}
`;
exports.StyledItem = StyledItem;
const StyledBlockListItem = styled_components_1.default.li `
    display: block;
`;
exports.StyledBlockListItem = StyledBlockListItem;
const StyledItemButton = styled_components_1.default.button `
    border: none;
    background: none;
    ${popoverItemStyles}
`;
exports.StyledItemButton = StyledItemButton;
const StyledItemLink = styled_components_1.default.a `
    text-decoration: none;
    ${popoverItemStyles}
`;
exports.StyledItemLink = StyledItemLink;
//# sourceMappingURL=Popover.styles.js.map